export var CallOutAlertVariant;
(function (CallOutAlertVariant) {
    CallOutAlertVariant["ICON"] = "ICON";
    CallOutAlertVariant["ILLUSTRATION"] = "ILLUSTRATION";
    CallOutAlertVariant["IMAGE"] = "IMAGE";
    CallOutAlertVariant["CONVERSATIONAL"] = "CONVERSATIONAL";
})(CallOutAlertVariant || (CallOutAlertVariant = {}));
export var CallOutAlertSize;
(function (CallOutAlertSize) {
    CallOutAlertSize["MEDIUM"] = "MEDIUM";
    CallOutAlertSize["LARGE"] = "LARGE";
})(CallOutAlertSize || (CallOutAlertSize = {}));
//# sourceMappingURL=callOutAlertTheme.js.map